<template>
  <div class="challenge box" v-if="challenge">
    <div v-if="confirmDeleteOpen" class="confirm-delete">
      <p>{{ $t('challenge.actions.confirmDelete') }}</p>
      <el-button @click="toggleConfirmDelete(true)" size="small">{{ $t('challenge.actions.cancel') }}</el-button>
      <el-button @click="remove" type="danger" size="small">{{ $t('challenge.actions.delete') }}</el-button>
    </div>
    <header class="title">
      <h3>{{ challenge.name[lang] }}</h3>
      <dropdown class="actions" :actions="action" @action="actions"></dropdown>
    </header>
    <div class="content">
      <div class="media" v-if="challenge.media.url">
        <img :src="challenge.media.url">
      </div>
      <p class="status tag" :class="challenge.status">{{ challenge.status }}</p>
      <p class="period tag">
        <span>{{ challenge.activationdate | date }}</span>&nbsp;|&nbsp;<span>{{ challenge.deactivationdate | date }}</span>
      </p>
      <p class="tag" v-if="challenge.category">Campaign linked : {{ challenge.category.name[lang] }}</p>
      <p class="description">{{ challenge.description[lang] }}</p>
      <el-progress :text-inside="true" :stroke-width="16" :percentage="damage"></el-progress>
    </div>
    <form-challenge v-if="isFormOpened" :id="challenge.id" @close="isFormOpened = false"></form-challenge>
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'
import dropdown from '@/components/dropdown'
import FormChallenge from '@/components/challenge/challenge-form.vue'
import formGroup from '@/components/layouts/form-group.vue'

export default {
  props: {
    id: {
      type: String,
      required: true
    }
  },
  components: { dropdown, FormChallenge, formGroup },
  data () {
    return {
      action: [{title: 'Delete', action: 'delete'}],
      type: 'monster',
      isFormOpened: false,
      confirmDeleteOpen: false,
      campaigns: [],
      campaignSelected: null
    }
  },
  computed: {

    ...mapGetters('challenges', {
      getById: 'getById'
    }),

    ...mapGetters('account', {
      lang: 'defaultLang',
      site: 'currentSite'
    }),

    challenge () {
      return this.getById(this.id)
    },
    damage () {
      let damage = Math.round((this.challenge.energy - this.challenge.damage) * 100 / this.challenge.energy)
      if (damage < 0) {
        damage = 0
      }
      if (damage > 100) {
        damage = 100
      }
      return damage
    }
  },
  methods: {
    ...mapActions('challenges', ['removeChallenge', 'updateChallenge']),

    actions (action) {
      switch (action) {
      case 'edit':
        this.isFormOpened = true
        break
      case 'delete':
        this.toggleConfirmDelete(false)
        break
      case 'publish':
        this.sendStatus(action)
        break
      case 'testing':
        this.sendStatus(action)
        break
      default:
        break
      }
    },

    updateActions (arr, value) {
      // remove old action
      let newActions = arr.filter(function (ele) {
        return ele.action !== value
      })
      // add new action
      if (value === 'publish') {
        newActions.unshift({title: 'Testing', action: 'testing'})
      } else if (value === 'testing') {
        newActions.unshift({title: 'Publish', action: 'publish'})
      }
      return newActions
    },

    sendStatus (action) {
      // define status and remove/add action
      let status
      if (action === 'publish') {
        status = 'enable'
      } else if (action === 'testing') {
        status = 'draft'
      }
      this.updateChallenge({challenge: {id: this.id, status: status}})
        .then(() => {
          // update actions
          this.action = this.updateActions(this.action, action)
          this.$notify({title: 'Success', message: this.$root.$t('notifications.challenge.published'), type: 'success'})
        })
        .catch((e) => {
          this.$notify.error({title: 'Error', message: this.$root.$t('notifications.unknown')})
        })
    },

    toggleConfirmDelete (isOpen) {
      this.confirmDeleteOpen = !isOpen
    },

    remove () {
      this.removeChallenge({challenge: this.challenge})
        .then(() => {
          this.$notify({title: 'Success', message: this.$root.$t('notifications.challenge.deleted'), type: 'success'})
        })
        .catch((e) => {
          this.$notify.error({title: 'Error', message: this.$root.$t('notifications.unknown')})
        })
    }
  },
  created () {
    if (this.challenge.status !== 'dead' && this.challenge.status !== 'survivor') {
      this.action.unshift({title: 'Edit', action: 'edit'})
    }
    if (this.challenge.status === 'draft') {
      this.action.unshift({title: 'Publish', action: 'publish'})
    } else if (this.challenge.status === 'enable') {
      this.action.unshift({title: 'Testing', action: 'testing'})
    }
  }
}
</script>

<style lang="scss" scoped>
    .challenge {
      background: #fff;
      padding: 16px 20px;
      position: relative;

      > header.title {
        display: grid;
        grid-template-columns: 1fr 20px;
        h3 {
          align-self: center;
          margin: 0;
        }
        .group-actions {
          .trigger {
            padding: 0;
          }
        }
      }
      .content {
        width: 100%;
        .media {
          width: 100%;
          img {
            display: inline-block;
            border-radius: 8px;
            width: 100%;
          }
        }
        .tag {
          border-radius: 4px;
          background: #dedede;
          text-align: center;
          font-weight: 600;
        }

        .description {
          color: #565656;
          text-align: justify;
          line-height: 1.4;
        }
      }
      .confirm-delete {
        position: absolute;
        z-index: 1;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(60,60,60, 0.9);
        padding: 30px 2px;
        text-align: center;
        p {
          color: #fff;
          font-size: 16px;
          margin: 10px 20px
        }
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/challenge/challenge.vue